var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallClearField(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.104 11.707l2.474 2.475a.75.75 0 01-1.06 1.06l-2.475-2.474-2.475 2.475a.75.75 0 01-1.06-1.061l2.474-2.475-2.475-2.475a.75.75 0 111.061-1.06l2.475 2.474 2.475-2.474a.75.75 0 111.06 1.06l-2.474 2.475zm-1.066 7.745a7.75 7.75 0 100-15.5 7.75 7.75 0 000 15.5z",
    id: "small_clear_field_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#CCC",
    xlinkHref: "#small_clear_field_svg__a",
    fillRule: "evenodd"
  })));
}
export default SvgSmallClearField;